<template>
    <div class="box">
        <div class="header">
            <Row v-if="hasPermission('addGlobalEffectGroupTemplate')" type="flex" class="toolbar">
                <Col span="24">
                <Button
                        ref="upload_btn"
                        @click="add"
                        icon="md-add"
                        type="primary"
                >{{ $t('directorManagement.departmentTemplate.button.add') }}</Button>
                </Col>
            </Row>
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('directorManagement.departmentTemplate.filter.nameLike') }}</span>
                        <Input
                            v-model="filter.nameLike"
                            class="selector"
                            size="small"
                            clearable
                            :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                </ul>
                <Button 
                    class="refresh-button" 
                    type="primary" 
                    size="small"
                    @click="refresh">
                    {{ $t('Button.refresh') }}
                </Button>
            </div>
        </div>
        <div ref="list" class="content">
            <ul class="list">
                <li
                    :key="p.id"
                    v-for="p in list"
                    class="item"
                >
                    <div class="item-thumb">
                         <MaterialTemplatePreview :data="p.data" :uploadServerUrl="p.uploadServerUrl"></MaterialTemplatePreview>
                    </div>

                    <div class="item-info">
                        <span class="title">
                            <span class="titleLink" :title="p.name">
                                {{p.name}}
                            </span>
                            <span v-if="p.vrFlag == 1" style="margin:0 5px 0 2px;position:relative;top:-1px">
                                <svg id="VRMark" style="height: 16px; vertical-align: middle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 385.62 151">
                                    <defs><svg:style>
                                        .cls-1{fill:#ffb354;} 
                                        #VRMark path{
                                            fill:#333;
                                            storke-width:0
                                        }
                                    </svg:style></defs>
                                    <title>vr</title>
                                    <rect class="cls-1" width="385.62" height="151" rx="50" ry="50"></rect>
                                    <path d="M171.69,125.07h-18.9A19.44,19.44,0,0,1,135,113.4l-2.07-4.73a7.63,7.63,0,0,0-14,0l-2.07,4.73A19.44,19.44,0,0,1,99,125.07H79.54A29.57,29.57,0,0,1,50,95.53V54.47A29.57,29.57,0,0,1,79.54,24.93h92.16a29.57,29.57,0,0,1,29.54,29.54V65.7a5.91,5.91,0,0,1-11.81,0V54.47a17.74,17.74,0,0,0-17.72-17.72H79.54A17.74,17.74,0,0,0,61.81,54.47V95.53a17.74,17.74,0,0,0,17.72,17.72H99a7.63,7.63,0,0,0,7-4.58l2.07-4.73a19.45,19.45,0,0,1,35.64,0l2.07,4.73a7.63,7.63,0,0,0,7,4.58h18.9a17.74,17.74,0,0,0,17.72-17.72,5.91,5.91,0,0,1,11.81,0A29.57,29.57,0,0,1,171.69,125.07Zm4.43-54.64A17.72,17.72,0,1,0,158.4,88.14,17.74,17.74,0,0,0,176.12,70.42Zm-11.81,0a5.91,5.91,0,1,1-5.91-5.91A5.91,5.91,0,0,1,164.31,70.42Zm-53.76,0A17.72,17.72,0,1,0,92.83,88.14,17.74,17.74,0,0,0,110.55,70.42Zm-11.81,0a5.91,5.91,0,1,1-5.91-5.91A5.91,5.91,0,0,1,98.74,70.42Z"></path><path d="M233.84,49.82h17.35l12.09,38.66,11.94-38.66h16.85l-19.95,53.72h-18Z"></path><path d="M297.71,103.54V49.82h27.67q7.69,0,11.76,1.32A12.52,12.52,0,0,1,343.7,56a14.84,14.84,0,0,1,2.49,8.7,14.36,14.36,0,0,1-7.15,13,20.07,20.07,0,0,1-5.83,2.13,16.61,16.61,0,0,1,4.32,2,16.77,16.77,0,0,1,2.65,2.83A20.94,20.94,0,0,1,342.51,88l8,15.57H331.8l-8.87-16.42a12.52,12.52,0,0,0-3-4.14,7,7,0,0,0-4.07-1.25h-1.47v21.8Zm16.67-32h7a25,25,0,0,0,4.4-.73,4.39,4.39,0,0,0,2.69-1.69,5.44,5.44,0,0,0-.61-7.11q-1.65-1.39-6.19-1.39h-7.29Z"></path>
                                </svg>
                            </span>
                            <span v-if="p.defaultFlag == 0" class="title-tag" style="background-color: yellow">
                                {{ $t('Tag.tagDefault') }}
                            </span>
                        </span>
                        <ul class="list">
                            <li>
                                <span class="title">{{ $t('directorManagement.departmentTemplate.list.id') }}</span>
                                <span class="content">{{ p.id }}</span>
                            </li>
                            <li>
                                <span class="title">{{ $t('directorManagement.departmentTemplate.list.depName') }}</span>
                                <span class="content">{{ p.depName }}</span>
                            </li>
                            <li>
                                <span class="title">{{ $t('directorManagement.departmentTemplate.list.userName') }}</span>
                                <span class="content">{{ p.userName }}</span>
                            </li>
                            <li>
                                <span class="title" >{{ $t('directorManagement.departmentTemplate.list.createDatetime') }}</span>
                                <span class="content">{{ p.createDatetime }}</span>
                            </li>
                        </ul>
                    </div>
                    <div v-if="depLevel == p.depLevel || isSuperAdmin" class="item-op">
                        <Button
                                v-if="hasPermission('updateGlobalDefaultFlag')"
                                :class="p.defaultFlag == 0 ? 'default_btn download_btn' : 'download_btn'"
                                type="dashed"
                                size="large"
                                :icon="p.defaultFlag == 1 ? 'md-checkmark' : 'md-close'"
                                style="margin-right: 5px"
                                @click.stop="setDefault(p.id, p.defaultFlag)"
                        >{{ p.defaultFlag == 1 ? $t('Button.setDefault') : $t('Button.cancelDefault') }}</Button>
                        <Button
                                v-if="hasPermission('editGlobalEffectGroupTemplate')"
                                class="edit_btn"
                                type="dashed"
                                size="large"
                                icon="md-settings"
                                @click="e=>e.stopPropagation()"
                                :to="'detail/'+ p.id +'/'+ p.userId"
                        >{{ $t('Button.edit') }}</Button>
                        <Button
                                v-if="hasPermission('copyGlobalEffectGroupTemplate')"
                                class="edit_btn"
                                type="dashed"
                                size="large"
                                icon="md-create"
                                @click="e=>e.stopPropagation()"
                                style="margin-left: 100px"
                                :to="'detail/'+ p.id + '/' + p.userId + '/true'"
                        >{{ $t('Button.copy.common') }}</Button>
                        <Button
                                v-if="hasPermission('deleteGlobalEffectGroupTemplate')"
                                type="dashed"
                                size="large"
                                icon="md-close"
                                style="margin-left: 100px"
                                @click.stop="remove(p.id,p.name)"
                        >{{ $t('Button.remove') }}</Button>
                    </div>
                </li>
            </ul>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                    class="pager"
                    :total="pagination.total"
                    :current="pagination.page"
                    :page-size="pagination.pageSize"
                    @on-change="v=>pagination.page=v"
                    @on-page-size-change="v=>pagination.pageSize=v"
                    show-elevator
                    show-sizer
            />
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    import apimodel from "@/model/ApiModel";
    import helper from "@/assets/helper.js";
    import MaterialTemplatePreview from "@/components/MaterialTemplatePreview";
    // import logger from "@/assets/log";
    // const log = logger("views:material:all");

    let { Const } = apimodel;

    export default {
        components: {
            MaterialTemplatePreview
        },
        mixins: [
            {
                methods: helper
            }
        ],
        data() {
            return {
                Const,
                loading: true,
                list: []
            };
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.departmentTemplate.all.filter;
                },
                set(v) {
                    this.$store.commit("views/departmentTemplate.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.departmentTemplate.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/departmentTemplate.all.pagination", v);
                }
            },
            ...mapState({
                currUserId: state => state.user.id,
                uploaderLoading: state =>
                    state.uploader.UploadServer.loadingStatus == "loading",
                uploaderReady: state =>
                    state.uploader.UploadServer.loadingStatus == "done",
                uploaderResult: state => state.uploader.newMaterialStatus,
                depLevel: state => state.department.depLevel,
                isSuperAdmin: state => state.permission.isSuperAdmin
            })
        },
        watch: {
            'filter.nameLike'() {
                if(this.containsInvaildChar(this.filter.nameLike)) {
                    return;
                }
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page"() {
                this.refresh();
                console.log(this.depLevel)
            },
            "pagination.pageSize"() {
                this.refresh();
            },
            uploaderResult(val) {
                let item = val[val.length - 1];
                if (!item.status) {
                    this.pagination.page == 1 && this.refresh();
                } else {
                    ;
                }
            }
        },
        methods: {
             // 默认模板
            async setDefault(id, defaultFlag){
                if (!confirm(this.$t('Message.set.confirmHead')
                        + `${ defaultFlag == 1 ? this.$t('Button.setDefault') : this.$t('Button.cancelDefault') }`
                        + this.$t('Message.set.templateConfirmTail') )) return;

                this.loading =true;

                try {
                    await api.call("groupMaterialTemplate/departmentDefaultFlagUpdate", {
                        id: id,
                        defaultFlag: defaultFlag == 1 ? 0 : 1
                    });

                    this.$Notice.success({ title: this.$t('Message.set.success') });

                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.set.error'), desc: e.resultMsg });
                }

                this.loading = false;
            },
            async add() {
                try {
                    this.$router.push('detail/0/'+ this.currUserId)
                } catch (e) {;}
            },
            async remove(id, title) {
                if (!confirm(this.$t('Message.remove.confirm') + `(${title}) ?`)) return;

                this.loading = true;

                try {
                    await api.call("groupMaterialTemplate/departmentDelete", {
                        id: id
                    });

                    this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.remove.error') + `(${title})`, desc: e.resultMsg });
                }
                this.loading = false;
            },
            async refresh() {
                this.loading = true;

                try {
                    let param = extend(true, {}, this.pagination, this.filter);
                    let ret = await api.call("groupMaterialTemplate/departmentList", param);

                    this.list = ret.list;
                    this.pagination.total = ret.total;
                } catch (e) {;}

                this.loading = false;
            }
        },
        async mounted() {
            //如果是 Cordova app 此页作为首页，回到本页后清楚历史记录
            if (this.isCordova() && navigator.app && navigator.app.clearCache) {
                navigator.app.clearHistory();
            }
            await this.refresh();
        },
        created() {},
        beforeDestroy() {

        }
    };
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    // .box {
    // }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }

            .search {
                width: 200px;
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }

    .filter{
        overflow:hidden;
        white-space: nowrap;
        position: relative;
    }
    .filter-expend{
        overflow: visible;
        white-space: normal;
        position: static;
        .filter-box li{
            margin:5px 5px;
        }
        .more-btn{
            position:relative
        }
    }

    .list {
        list-style: none;
        padding: 0 7px;
        border-radius: 5px;
        background: white;

        .titleLink:hover {
            text-decoration: none;
            cursor: text;
        }

        .item {
            border-bottom: 1px solid #e9e9e8;
            height: 140px;
            padding: 15px 0;
            white-space: nowrap;
            position: relative;
            overflow: hidden;
            & > * {
                /*height: 100%;*/
                display: inline-block;
                vertical-align: middle;
            }

            .title-tag {
                border-radius: 5px;
                font-size: 12px;
                background: #e3e3e3;
                padding: 2px 4px;
            }
            .item-thumb {
                height: 90px;
                // 如果设置 line-height: 90px 内容会下移1px，原因不明
                line-height: 89px;
                width: 160px;
                border-radius: 5px;
                overflow: hidden;
                margin-right: 12px;
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    vertical-align: middle;
                    border: 0;
                }
            }
            .item-info {
                & > .title {
                    font-size: 15px;
                    color: #666;
                    & > * {
                        vertical-align: middle;
                    }
                    a {
                        margin-left: 5px;
                    }
                }
                .list {
                    color: #989898;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    line-height: 19px;

                    .title {
                        width: 60px;
                        display: inline-block;
                    }
                    .title:after {
                        content: ":";
                    }
                    .video-level-tag {
                        border-radius: 2px;
                        margin-right: 5px;
                        border-bottom: 1px dashed #e3e3e3;
                        cursor: pointer;
                    }
                    .video-level-tag:after {
                        content: "、";
                    }
                    .video-level-tag:last-child:after {
                        content: "";
                    }
                }
            }
            .item-op {
                position: absolute;
                right: 0;
                height: auto;
                width: 200px;
                background: white;
                text-align: right;
                white-space: normal;
                .delete_btn2 {
                    display: none;
                }
                .default_btn{
                    background-color: yellow;
                }
            }
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }

    @media only screen and (max-width: 1440px) {
        .list .item .item-info > .title a {
            width: 80%;
        }
    }

    @media all and (orientation: portrait), all and (max-width: 1024px) {
        .list .item .item-op {
            background: transparent;
            .edit_btn {
                display: none;
            }
            .download_btn {
                display: none;
            }
            .delete_btn {
                display: none;
            }
            .delete_btn2 {
                display: inline-block;
            }
            bottom: 10px;
        }
        .list .item .item-thumb {
            width: 60px;
        }
        .content {
            padding: 0;
        }
    }
</style>